import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje } from "../components/mensajes";

import useTable from "../components/useTableR";

import axios from "axios";
import { Dimmer } from "../components/spinner";

const CatalogoInmueble = (props) => {
  let op = require("../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");

  const btnCancela = useRef();
  const [mostrar, setMostrar] = useState(false);
  const [titulo, setTitulo] = useState();
  const [msg, setMsg] = useState();
  const [activate, setActivate] = useState(false);
  const [records, setRecords] = useState([]);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const [values, setValues] = useState({});
  const [itemSelect, setItemSelect] = useState(-1);
  const [activo, setActivo] = useState(true);

  const headCells = [
    {
      id: "idinmueble",
      label: "CODIGO",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },

    {
      id: "numficha",
      label: "Nº FICHA RITM",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "nombrepropie",
      label: "NOMBRE PROPIETARIO",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "dirinmueble",
      label: "DIRECCION",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "codigocatastral",
      label: "CODIGO CATASTRAL",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "cedulapropie",
      label: "CEDULA PROPIETARIO",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
  ];

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;

    setFilterFn({
      fn: (items) => {
        if (target.value === "") {
          return items;
        } else {
          return items.filter((x) => {
            if (
              (x.idinmueble.includes(target.value) === null
                ? ""
                : x.idinmueble.includes(target.value)) ||
              (x.numficha === null
                ? ""
                : x.numficha
                    .toLowerCase()
                    .includes(target.value.toLowerCase())) ||
              (x.nombrepropie === null
                ? ""
                : x.nombrepropie
                    .toLowerCase()
                    .includes(target.value.toLowerCase()))
            ) {
              return x;
            }
          });
        }
      },
    });
  };

  const seleccionarInmueblesTodos = () => {
    let endpoint = `${op.conexion}/api/catalogo/inmuebles`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setRecords(response.data);
        }

        setActivate(false);
      })
      .catch(function (error) {
        setTitulo("ERROR");
        setMsg(error.response.data.message);
        setMostrar(true);
        setActivate(false);
      });
  };

  const blanquear = () => {
    setMostrar(false);
    setTitulo("");
    setMsg("");
    setActivate(false);
    setRecords([]);
    setFilterFn({
      fn: (items) => {
        return items;
      },
    });
  };

  const handleCloseMensa = () => {
    setMostrar(false);
  };

  const cancelar = () => {
    blanquear();
    props.onHideCancelaCatInm();
  };

  const seleccionarLista = (index) => (event) => {
    cancelar();
    if (props.caja) {
      props.onHideAceptaCatInm(values[0].idInmue);
    } else {
      props.onHideAceptaCatInm(
        values[0].idInmue,
        values[0].nomPropie,
        values[0].codCat,
        values[0].cedPropie,
        values[0].dirInmue,
      );
    }
  };

  const seleccionarFila = (index) => (event) => {
    setItemSelect(index);
    setActivo(false);

    var idInmue = recordsAfterPagingAndSorting()[index].idinmueble;
    var nomPropie = recordsAfterPagingAndSorting()[index].nombrepropie;
    var codCat = recordsAfterPagingAndSorting()[index].codigocatastral;
    var cedPropie = recordsAfterPagingAndSorting()[index].cedulapropie;
    var dirInmue = recordsAfterPagingAndSorting()[index].dirinmueble;

    var datos = [];

    datos.push({
      idInmue,
      nomPropie,
      codCat,
      cedPropie,
      dirInmue,
    });
    setValues(datos);
  };

  return (
    <Modal
      {...props}
      size="xl"
      style={{
        backgroundColor: "rgba(0, 0, 0, 0.521)",
      }}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        seleccionarInmueblesTodos();
      }}
    >
      <Modal.Header className="azulGradiant">
        <Modal.Title style={{ color: "#fff" }}>
          Seleccionar Inmueble.
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Mensaje
          titulo={titulo}
          mensaje={msg}
          show={mostrar}
          onHide={handleCloseMensa}
        />
        <Dimmer active={activate} inverted></Dimmer>
        <div className="col-md-12 m-0">
          <div className="input-group input-group-sm mb-3 m-0 col-md-5">
            <input
              type="text"
              onChange={handleSearch}
              className="form-control rounded-pill search-input"
            />
          </div>
        </div>
        <div className="col-md-12" style={{ margin: "auto" }}>
          <TblContainer>
            <TblHead />
            <tbody>
              {records &&
                recordsAfterPagingAndSorting().map((item, index) => (
                  <tr
                    key={item.idinmueble}
                    style={{
                      padding: "0",
                      cursor: "pointer",
                      background:
                        itemSelect === index ? "lightskyblue" : "white",
                    }}
                    onClick={seleccionarFila(index)}
                  >
                    <td
                      style={{
                        fontSize: "10px",
                        textAlign: "left",
                        width: "10px",
                        verticalAlign: "middle",
                      }}
                    >
                      {item.idinmueble}
                    </td>
                    <td
                      style={{
                        fontSize: "10px",
                        textAlign: "left",
                        width: "150px",
                        verticalAlign: "middle",
                      }}
                    >
                      {item.numficha}
                    </td>
                    <td
                      style={{
                        fontSize: "10px",
                        textAlign: "left",
                        width: "250px",
                        verticalAlign: "middle",
                      }}
                    >
                      {item.nombrepropie}
                    </td>
                    <td
                      style={{
                        fontSize: "10px",
                        textAlign: "left",
                        width: "auto",
                        verticalAlign: "middle",
                      }}
                    >
                      {item.dirinmueble}
                    </td>
                    <td
                      style={{
                        fontSize: "10px",
                        textAlign: "left",
                        width: "150px",
                        verticalAlign: "middle",
                      }}
                    >
                      {item.codigocatastral}
                    </td>
                    <td
                      style={{
                        fontSize: "10px",
                        textAlign: "left",
                        width: "200px",
                        verticalAlign: "middle",
                      }}
                    >
                      {item.cedulapropie}
                    </td>
                    {/*     <td align="center" style={{ fontSize: "10px", textAlign: "center", width: "120px", padding: 0, verticalAlign: "middle" }}>
                                            <button style={{ width: "120px" }} onClick={seleccionarInmueble(index)} className="btn btn-outline-info"><i className="fas fa-edit">Seleccionar</i> </button>
                                        </td> */}
                  </tr>
                ))}
            </tbody>
          </TblContainer>
          <TblPagination />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn btn-sm btn-success rounded-pill"
          disabled={activo}
          style={{ margin: "5px" }}
          onClick={seleccionarLista()}
        >
          <i className="fas fa-check-circle"> Aceptar</i>{" "}
        </button>
        <button
          ref={btnCancela}
          onClick={cancelar}
          className="btn btn-danger btn-sm rounded-pill col-md-2"
        >
          <i className="fa"> Cancelar</i>
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default CatalogoInmueble;
